import { render } from "./EmployeeProfileForm.vue?vue&type=template&id=ec24d488&scoped=true"
import script from "./EmployeeProfileForm.vue?vue&type=script&lang=js"
export * from "./EmployeeProfileForm.vue?vue&type=script&lang=js"

import "./EmployeeProfileForm.vue?vue&type=style&index=0&id=ec24d488&scoped=true&lang=css"

import exportComponent from "C:\\Users\\mridu\\BGI_Project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec24d488"]])

export default __exports__